// extracted by mini-css-extract-plugin
export default {"body":"Footer_body__emm9z","copyright":"Footer_copyright__2WB24"};